import {CollectionOperatorEnum} from '@/services/api-clients';
import i18n from '@/i18n/config';
import {LF} from '@/i18n/LF';

export function collectionOperatorNameFilter(type: CollectionOperatorEnum) {
  switch (type) {
    case CollectionOperatorEnum.AtLeastOneOfSelected: return i18n.t(LF.Or) as string;
    case CollectionOperatorEnum.AllIncluded: return i18n.t(LF.And) as string;
  }
}
